import { Fragment } from "react";
import { Card, CardBody, CardHeader, CardTitle } from "reactstrap";

const Overview = () => {
  return (
    <Fragment>
      <Card>
        <CardHeader tag="h4">
          <CardTitle> Property Overview</CardTitle>
          {/* <Button color="primary">New Agreement</Button> */}
        </CardHeader>
        <CardBody>
          <div className="react-dataTable user-view-account-projects"></div>
        </CardBody>
      </Card>
    </Fragment>
  );
};

export default Overview;
